import React from "react";
import { useLocale } from "@davi-ai/retorik-framework";
import commonTranslation from '../../translations/common.json';

interface ChooseItemProps {
  current: boolean,
  item: string,
  setItem: (item: string | undefined) => void
}

const ChooseItem = ({
  current,
  item,
  setItem
}: ChooseItemProps) => {
  const locale = useLocale();

  const handleClick = (open: boolean) => {
    open ?
      setItem(item)
      :
      setItem(undefined)
  }

  return (
    <div className="w-full text-center py-1 cursor-pointer border border-red-800 shadow-inner">
      {current ?
        <div onClick={() => handleClick(false)}>
          {commonTranslation[locale]?.closeoptions || commonTranslation["fr-FR"].closeoptions}
        </div>
        :
        <div onClick={() => handleClick(true)}>
          {commonTranslation[locale]?.openoptions || commonTranslation["fr-FR"].openoptions}
        </div>
      }
    </div>
  );
};

export default ChooseItem;
